'use strict';

import BiBaseDataItem from './bi-base-item';

/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
export default class BiLoadFinishDataItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(11, sessionId);
  }
}



// WEBPACK FOOTER //
// ./data-items/bi-load-finish-item.js